module.exports = __webpack_public_path__ + "static/media/may.7af863e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Aya/may.png
// module id = 155
// module chunks = 0